import React from 'react'
import { string, bool } from 'prop-types'
import Alert from '@active/react-ui/Alert'
import { withI18n } from '@active/react-utils/i18n'
import I18nMessage from '../I18nMessage'

const icons = ['success', 'warning', 'danger', 'info'] // error should be dafault to danger
function CommonError(props) {
  const { showError, msgType, errMsg } = props

  const alertType = icons.find(i => i === (msgType && msgType.toLowerCase())) || 'danger'

  return showError && (
    <Alert type={alertType} noclose="true" theme="inline" className="passport-ui-app__common-info passport-ui-app__common-error">
      <I18nMessage id={errMsg || 'passport.error.server.default'} />
    </Alert>
  )
}

CommonError.propTypes = {
  showError: bool.isRequired,
  errMsg: string,
  msgType: string,
}

CommonError.defaultProps = {
  errMsg: '',
  msgType: 'danger',
}

export default withI18n(CommonError)
